(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/init.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const _svs$widgetsCampaign$ = svs.widgetsCampaign.components,
  Background = _svs$widgetsCampaign$.Background,
  PreambleHeader = _svs$widgetsCampaign$.PreambleHeader;
const frames = svs.widgetsCampaign.frames;
const availableFrames = {
  jul2023: frames.christmas2023.Christmas,
  valentines2024: frames.valentines2024.Valentines,
  valentinesSplit2024: frames.valentinesSplit2024.Valentines,
  easter2024: frames.easter2024.Easter,
  mothersDay2024: frames.mothersDay2024.MothersDay,
  fathersDay2024: frames.fathersDay2024.FathersDay,
  valentines2025: frames.valentines2025.Valentines,
  mothersDay2025: frames.mothersDay2025.MothersDay,
  jul2025: frames.christmas2025.Christmas
};
const _svs$widgetsCampaign$2 = svs.widgetsCampaign.data.moduleConfig,
  chosenFrame = _svs$widgetsCampaign$2.frame,
  customBg = _svs$widgetsCampaign$2.customBg,
  textColor = _svs$widgetsCampaign$2.textColor,
  frameCoverage = _svs$widgetsCampaign$2.frameCoverage;
const Frame = availableFrames[chosenFrame] || Fragment;
const showTop = [undefined, '', 'full', 'top'].includes(frameCoverage);
const showBottom = [undefined, '', 'full', 'bottom'].includes(frameCoverage);
svs.widgetsCampaign.init = () => {
  Frame && ReactDOM.render(React.createElement(Fragment, null, React.createElement(Background, {
    image: customBg
  }), React.createElement(Frame, {
    showBottom: showBottom,
    showTop: showTop
  }, React.createElement(PreambleHeader, {
    color: textColor
  }), React.createElement(WidgetArea, {
    areaName: "moduleMain",
    className: "relative widget-area-campaign"
  }))), document.getElementById('reactContainer'));
};
svs.widgetsCampaign.init();

 })(window);